import React from 'react';
import SectionHeader from './SectionHeader';
import './CoursesOfferedSection.css';
import { mapIndexed } from '../resources/utils/utilities'
import R from 'ramda';
import classNames from 'classnames';

class CoursesOfferedSection extends React.Component {
  constructor() {
    super();
    this.courseInfoLi = this.courseInfoLi.bind(this);
    this.toggleDescription = this.toggleDescription.bind(this);
  }

  close(openCourseDescriptions) {
    R.forEach(courseDescription => courseDescription.classList.remove('open'), openCourseDescriptions);
  }

  toggleDescription(e) {
    if (e) {
      e.preventDefault()
      e.currentTarget.nextSibling.classList.toggle('open');
    }
  }

  courseInfoLi(course, index) {
    const title = R.prop('title', course);
    const courseDescription = R.prop('description', course)
    const courseDescriptionClass = classNames('row', 'course-description',
      {'open': R.prop('showDescription', course)}
    );
    return (
      <li key={index}>
        <div className='row course-info-row'>
          <div className='course-title' onClick={this.props.toggleCourseDescription}>
            <a href='#'>{title}</a>
          </div>
          <div className={courseDescriptionClass}>
            {courseDescription}
          </div>
        </div>
      </li>
    )
  }

  render() {
    const getCourseInfoLiWithIndex = mapIndexed(this.courseInfoLi);
    return (
    <section className='courses-offered-section'>
      <SectionHeader item={R.prop('sectionHeader', this.props)} />
        <div>
          <ul>
            {getCourseInfoLiWithIndex(R.prop('courses', this.props))}
          </ul>
        </div>
      </section>
    );
  }
}

CoursesOfferedSection.propTypes = {
  toggleCourseDescription: React.PropTypes.func.isRequired,
  sectionHeader: React.PropTypes.object.isRequired,
  courses: React.PropTypes.array.isRequired
}

export default CoursesOfferedSection;



// WEBPACK FOOTER //
// ./src/components/CoursesOfferedSection.js